import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './factorybill.css';

function FactoryBill() {
    const { state } = useLocation();
    const navigate = useNavigate();

    if (!state || !state.formData) {
        return <div>No data found. <button onClick={() => navigate(-1)}>Go Back</button></div>;
    }

    const {
         date, time, factoryname, farea,
        bagqty, quantity, water, stick, tare,
        netweight, description
    } = state.formData;

    return (
        <div className="factory-bill">
            <h2>Factory Receipt</h2>
            <p><strong>Date:</strong> {date}</p>
            <p><strong>Time:</strong> {time}</p>

            <hr />

            <p><strong>Factory:</strong> {factoryname}</p>
        

           

            <table className="factory-table">
  <tbody>
    <tr><td>Bag Quantity</td><td>{bagqty}</td></tr>
    <tr><td>Gross Quantity</td><td>{quantity}</td></tr>
    <tr><td>Water</td><td>{water}</td></tr>
    <tr><td>Stick</td><td>{stick}</td></tr>
    <tr><td>Tare</td><td>{tare}</td></tr>
    <tr className="highlight-row">
      <td><strong>Net Weight</strong></td><td><strong>{netweight}</strong></td>
    </tr>
  </tbody>
</table>
            <p><strong>Description:</strong> {description || 'N/A'}</p>

            <div style={{ marginTop: '20px' }}>
                <button onClick={() => window.print()}>🖨️ Print</button>
                <button onClick={() => navigate('/emppage')}>🏠 Home</button>
            </div>
        </div>
    );
}

export default FactoryBill;
